var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 267.287C210.298 267.287 267.287 210.298 267.287 140C267.287 69.7012 210.298 12.7129 140 12.7129C69.7012 12.7129 12.7129 69.7012 12.7129 140C12.7129 210.298 69.7012 267.287 140 267.287Z",
    fill: "url(#paint0_linear_1533_7558)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140 267.287C210.298 267.287 267.287 210.298 267.287 140C267.287 69.7012 210.298 12.7129 140 12.7129C69.7012 12.7129 12.7129 69.7012 12.7129 140C12.7129 210.298 69.7012 267.287 140 267.287Z",
    fill: "url(#paint1_linear_1533_7558)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140 12.7158C69.7031 12.7158 12.7148 69.7041 12.7148 140.001C12.7148 210.297 69.7031 267.285 140 267.285C210.296 267.285 267.284 210.297 267.284 140.001C267.284 69.7041 210.296 12.7158 140 12.7158ZM140 179.87C70.7133 179.87 14.5486 162.022 14.5486 140.001C14.5486 117.979 70.7133 100.131 140 100.131C209.286 100.131 265.451 117.979 265.451 140.001C265.451 162.022 209.286 179.87 140 179.87Z",
    fill: "url(#paint2_linear_1533_7558)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140 179.872C209.284 179.872 265.451 162.021 265.451 140C265.451 117.979 209.284 100.127 140 100.127C70.7151 100.127 14.5488 117.979 14.5488 140C14.5488 162.021 70.7151 179.872 140 179.872Z",
    fill: "url(#paint3_linear_1533_7558)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M279.991 140.738C279.997 140.488 280 140.242 280 140C280 139.758 279.997 139.512 279.991 139.262C279.801 102.143 265.264 67.273 238.995 41.0046C212.726 14.7368 177.857 0.199294 140.737 0.00878431C140.488 0.00329412 140.242 0 140 0C139.758 0 139.512 0.00329412 139.263 0.00878431C102.143 0.199294 67.2736 14.7368 41.0052 41.0052C14.7368 67.2736 0.199294 102.143 0.00878431 139.262C0.00329412 139.512 0 139.758 0 140C0 140.242 0.00329412 140.488 0.00878431 140.738C0.199294 177.857 14.7362 212.727 41.0046 238.995C67.273 265.264 102.142 279.801 139.262 279.991C139.512 279.997 139.758 280 139.999 280C140.241 280 140.488 279.997 140.737 279.991C177.857 279.801 212.726 265.263 238.994 238.995C265.263 212.726 279.801 177.857 279.991 140.738ZM224.445 161.827C217.415 164.544 209.626 166.877 201.251 168.798C202.057 159.432 202.473 149.79 202.473 140.001C202.473 130.211 202.057 120.569 201.251 111.203C209.625 113.124 217.415 115.457 224.445 118.174C243.993 125.73 252.743 134.581 252.743 140.001C252.743 145.42 243.993 154.271 224.445 161.827ZM140 252.743C134.58 252.743 125.729 243.993 118.173 224.445C115.456 217.415 113.123 209.626 111.202 201.251C120.568 202.057 130.21 202.473 139.999 202.473C149.789 202.473 159.431 202.057 168.797 201.251C166.876 209.625 164.543 217.415 161.826 224.445C154.271 243.993 145.42 252.743 140 252.743ZM140 175.216C128.5 175.216 117.277 174.604 106.576 173.424C105.396 162.723 104.784 151.5 104.784 140C104.784 128.5 105.396 117.277 106.576 106.576C117.277 105.396 128.5 104.784 140 104.784C151.5 104.784 162.723 105.396 173.424 106.576C174.604 117.277 175.216 128.5 175.216 140C175.216 151.5 174.604 162.723 173.424 173.424C162.723 174.604 151.5 175.216 140 175.216ZM27.2566 140C27.2566 134.58 36.0069 125.729 55.5547 118.173C62.5855 115.456 70.3744 113.123 78.7486 111.202C77.9427 120.568 77.5271 130.21 77.5271 139.999C77.5271 149.789 77.9427 159.431 78.7486 168.797C70.375 166.876 62.5855 164.543 55.5547 161.826C36.0069 154.271 27.2566 145.42 27.2566 140ZM140 27.2566C145.42 27.2566 154.271 36.0069 161.827 55.5547C164.544 62.5855 166.877 70.3744 168.798 78.7486C159.432 77.9427 149.79 77.5271 140.001 77.5271C130.211 77.5271 120.569 77.9427 111.203 78.7486C113.124 70.375 115.457 62.5855 118.174 55.5547C125.729 36.0069 134.58 27.2566 140 27.2566ZM244.316 97.0771C241.025 95.5047 237.674 94.0613 234.271 92.7503C223.321 88.5179 210.866 85.1074 197.405 82.5945C194.892 69.1337 191.482 56.6786 187.249 45.7284C185.938 42.3253 184.495 38.9746 182.922 35.6841C196.521 41.2791 209.01 49.5671 219.721 60.2785C230.433 70.9899 238.721 83.4779 244.316 97.0771ZM60.278 60.2785C70.9893 49.5671 83.4779 41.2791 97.0766 35.6841C95.5042 38.9747 94.0608 42.3253 92.7497 45.7284C88.5173 56.6786 85.1068 69.1337 82.594 82.5945C69.1331 85.1074 56.678 88.5179 45.7278 92.7503C42.3247 94.0613 38.9741 95.5047 35.6835 97.0771C41.2791 83.4779 49.5666 70.9899 60.278 60.2785ZM35.6841 182.923C38.9747 184.495 42.3253 185.939 45.7284 187.25C56.6786 191.482 69.1337 194.893 82.5945 197.406C85.1074 210.866 88.5179 223.321 92.7503 234.271C94.0613 237.674 95.5047 241.025 97.0771 244.315C83.4784 238.72 70.9899 230.432 60.2785 219.721C49.5666 209.01 41.2791 196.522 35.6841 182.923ZM182.923 244.316C184.495 241.025 185.939 237.675 187.25 234.272C191.482 223.321 194.893 210.866 197.406 197.406C210.866 194.893 223.321 191.483 234.272 187.25C237.675 185.939 241.026 184.496 244.316 182.923C238.721 196.523 230.433 209.011 219.722 219.722C209.01 230.433 196.522 238.721 182.923 244.316Z",
    fill: "url(#paint4_linear_1533_7558)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58008 179.312C12.0728 201.637 24.1067 222.097 41.0045 238.995C67.2729 265.264 102.142 279.801 139.262 279.991C139.512 279.997 139.758 280 139.999 280C140.241 280 140.487 279.997 140.737 279.991C177.856 279.801 212.726 265.263 238.994 238.995C255.892 222.098 267.926 201.637 274.419 179.312H5.58008ZM60.2773 219.722C49.5659 209.01 41.2779 196.522 35.6828 182.923C38.9734 184.495 42.324 185.939 45.7271 187.25C56.6773 191.482 69.1324 194.893 82.5933 197.406C85.1061 210.866 88.5166 223.321 92.749 234.271C94.06 237.674 95.5034 241.025 97.0758 244.315C83.4772 238.721 70.9892 230.433 60.2773 219.722ZM161.826 224.445C154.27 243.993 145.419 252.743 139.999 252.743C134.579 252.743 125.729 243.993 118.172 224.445C115.455 217.415 113.123 209.626 111.201 201.251C120.567 202.057 130.209 202.473 139.999 202.473C149.788 202.473 159.43 202.057 168.796 201.251C166.875 209.625 164.543 217.415 161.826 224.445ZM219.721 219.722C209.01 230.433 196.521 238.721 182.923 244.316C184.495 241.025 185.938 237.675 187.25 234.272C191.482 223.321 194.892 210.866 197.405 197.406C210.866 194.893 223.321 191.483 234.271 187.25C237.675 185.939 241.025 184.496 244.316 182.924C238.72 196.522 230.433 209.01 219.721 219.722Z",
    fill: "url(#paint5_linear_1533_7558)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M238.994 238.995C251.801 226.188 261.811 211.333 268.738 195.173L175.433 101.867C173.978 99.5856 171.643 97.8188 168.606 97.1968L94.6253 82.0444C87.1317 80.5093 80.5084 87.1327 82.0434 94.6263L97.1958 168.607C97.8179 171.644 99.5846 173.979 101.866 175.434L195.172 268.739C211.332 261.812 226.187 251.802 238.994 238.995Z",
    fill: "url(#paint6_linear_1533_7558)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.448 159.126L159.125 190.449L222.099 253.423C234.12 244.691 244.69 234.121 253.422 222.1L190.448 159.126Z",
    fill: "url(#paint7_linear_1533_7558)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195.723 164.4L159.704 128.381L173.457 114.629C179.462 108.624 176.378 98.3521 168.059 96.648L94.0784 81.4956C86.5849 79.9605 79.9615 86.5839 81.4965 94.0774L96.6489 168.058C98.3531 176.377 108.625 179.461 114.629 173.456L128.382 159.704L164.401 195.723C168.409 199.731 174.907 199.731 178.914 195.723L195.724 178.913C199.731 174.905 199.731 168.408 195.723 164.4Z",
    fill: "url(#paint8_linear_1533_7558)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M195.723 164.4L159.704 128.381L128.381 159.704L164.4 195.722C168.408 199.73 174.905 199.73 178.913 195.722L195.723 178.913C199.73 174.905 199.73 168.407 195.723 164.4Z",
    fill: "url(#paint9_linear_1533_7558)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5892 130.911L128.383 159.704L114.63 173.457C108.623 179.458 98.3511 176.378 96.6492 168.055L90.0873 136.025C89.9002 135.112 89.9426 134.167 90.2106 133.274C90.4786 132.382 90.9639 131.57 91.6229 130.911C93.8228 128.711 97.3893 128.711 99.5892 130.911Z",
    fill: "url(#paint10_linear_1533_7558)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M173.458 114.63L159.705 128.383L130.912 99.5892C128.712 97.3893 128.712 93.8223 130.912 91.6224C131.571 90.9635 132.383 90.4784 133.275 90.2105C134.167 89.9426 135.112 89.9003 136.025 90.0873L168.055 96.6492C176.379 98.3511 179.459 108.623 173.458 114.63Z",
    fill: "url(#paint11_linear_1533_7558)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1533_7558",
    x1: -22.191,
    y1: -22.191,
    x2: 214.393,
    y2: 214.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#518EF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1533_7558",
    x1: 125.625,
    y1: 125.625,
    x2: 228.388,
    y2: 228.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1533_7558",
    x1: 140,
    y1: 81.8045,
    x2: 140,
    y2: 12.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1533_7558",
    x1: 140,
    y1: 141.647,
    x2: 140,
    y2: 99.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#3D6BE4",
    stopOpacity: 0.161
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#3660BF",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#3259A7",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1533_7558",
    x1: 41.0052,
    y1: 41.0052,
    x2: 238.995,
    y2: 238.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#518EF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1533_7558",
    x1: 139.999,
    y1: 210.604,
    x2: 139.999,
    y2: 276.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1533_7558",
    x1: 193.621,
    y1: 193.622,
    x2: 125.463,
    y2: 125.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#3D6BE4",
    stopOpacity: 0.161
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#3660BF",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#3259A7",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1533_7558",
    x1: 205.516,
    y1: 205.516,
    x2: 166.874,
    y2: 166.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4071F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#3D6BE4",
    stopOpacity: 0.161
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#3660BF",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#3259A7",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30569F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1533_7558",
    x1: 114.151,
    y1: 114.15,
    x2: 171.792,
    y2: 171.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE7FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1533_7558",
    x1: 174.908,
    y1: 174.908,
    x2: 187.965,
    y2: 187.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AAADC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AAADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1533_7558",
    x1: 108.333,
    y1: 160.957,
    x2: 118.222,
    y2: 170.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AAADC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AAADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1533_7558",
    x1: 160.958,
    y1: 108.333,
    x2: 170.847,
    y2: 118.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AAADC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AAADC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7e04d6cd4d14ac91ffe627cb3c1bbabf.svg";
export { ForwardRef as ReactComponent };